import React, { useState } from "react";

import { AddWidgetConfig, WidgetComponents } from "constants/widgets.constant";

import CustomModal from "components/CustomModal";

import "./index.scss";

export default function AddWidgetModal(props) {
  const { page } = props.data;
  const [CurrentWidget, setCurrentWidget] = useState();
  const [openModal, setOpenModal] = useState(true);
  const widgetsConfig = AddWidgetConfig[page];

  const listItemClickHandler = item => {
    setCurrentWidget(item.id);
  };

  const modalClosed = closeType => {
    setCurrentWidget(null);
    if (!closeType) {
      setOpenModal(false);
      props.setIsAddWidgetFormOpen(false);
    }
  };

  return (
    <>
      <CustomModal show={openModal} title={widgetsConfig.title} close={modalClosed} description={widgetsConfig.description}>
        {widgetsConfig.items.map(groupItem => (
          <div key={groupItem.groupId}>
            <div className="group-name" style={{ color: groupItem.style }}>
              {groupItem.groupName}
            </div>
            <ul className="list flex-column">
              {groupItem.widgets.map(item => (
                <li className="list-item" key={item.id} onClick={() => listItemClickHandler(item)}>
                  <img className="margin-right-10" src={item.icon} alt="gauge-center" />
                  <div>{item.label}</div>
                  <div className="widgetRowAddBtn" />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </CustomModal>
      {CurrentWidget && React.createElement(WidgetComponents[CurrentWidget], { onClose: modalClosed, data: props.data, admin: props.admin })}
    </>
  );
}
